import axiosInstance from '../axiosInterceptor/axiosInstance'

const getSeasonsByTeam = async ({ orgId, teamId }) => {
  const url = `v1/orgs/${orgId}/seasons`
  const response = await axiosInstance.get(url, { params: { teamId } })
  return response?.data
}

export default getSeasonsByTeam
